<template>
  <div class="list-info-wrapper">
    <Banner :bannerImg="Img1"></Banner>

    <!-- 面包屑 -->
    <div class="Crumbs container-fixed">
      <div>
        当前位置：<router-link to="/">首页</router-link> &gt;
        <router-link to="/invitation">广西招投标公告</router-link> &gt;
        <span>采购公告详情</span>
      </div>
    </div>

    <main class="main-content container-fixed">
      <article class="detail-card card-modern" v-loading="loading">
        <header class="detail-header">
          <h1 class="title">{{ caigouInfo.title }}</h1>
          <div class="meta-info">
            <span
              ><i class="el-icon-user"></i> 来源：{{ caigouInfo.author }}</span
            >
            <span
              ><i class="el-icon-time"></i> 发布时间：{{
                caigouInfo.publishDate
              }}</span
            >
            <span
              ><i class="el-icon-view"></i> 浏览量：{{ caigouInfo.click }}</span
            >
          </div>
        </header>

        <div
          class="detail-body rich-text-content"
          v-html="caigouInfo.content"
          @click="handleClick"
        ></div>

        <div class="gov-link-box">
          <i class="el-icon-link"></i>
          <span>广西政府采购网官方公告：</span>
          <a :href="govHttpAddress">点击查看原文</a>
        </div>
      </article>
    </main>
  </div>
</template>

<script>
import Banner from "@/components/banner.vue";
import article from "@/api/article";
import axios from "axios";

export default {
  name: "ListInfo",
  components: {
    Banner,
  },
  data() {
    return {
      Img1: require("@/assets/images/banner1.png"),
      loading: false,
      caigouInfo: {},
      govHttpAddress: "",
      startTime: 0,
      stayTime: 0,
      ip: "",
    };
  },
  created() {
    if (this.$route.query) {
      let articleId = this.$route.query.articleId;
      this.getList(articleId);
    }
  },
  mounted() {
    this.getIP();
    this.startTime = new Date().getTime();
  },
  beforeDestroy() {
    const endTime = new Date().getTime();
    this.stayTime = Math.floor((endTime - this.startTime) / 1000);
    article
      .browseRecord({
        plateName: "广西招投标项目信息",
        title: this.caigouInfo.title,
        downName: "",
        clickNumber: 1,
        browseTime: this.stayTime,
        isattach: 2,
        areaIp: this.ip || "",
        equipment: "",
      })
      .then(() => {});
  },
  methods: {
    getList(articleId) {
      this.loading = true;
      article
        .getDetail({ articleId: articleId })
        .then((res) => {
          this.caigouInfo = res.data.data;
          this.govHttpAddress = `http://zfcg.gxzf.gov.cn/site/detail?parentId=66485&articleId=${this.caigouInfo.articleId}&utm=site.site-PC-38919.1024-pc-wsg-secondLevelPage-front.1.5320e5d0c37c11ee8334dd6d4134a42f`;
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
    getIP() {
      axios
        .get("https://api.ipify.org?format=json")
        .then((res) => {
          this.ip = res.data.ip;
        })
        .catch((err) => {
          console.error("获取IP地址失败:", err);
          this.ip = "无法获取";
        });
    },
    handleClick(e) {
      let clickElement = e.target;
      if (clickElement.tagName === "A") {
        article
          .browseRecord({
            plateName: "广西招投标项目信息",
            title: this.caigouInfo.title,
            downName: clickElement.innerHTML,
            clickNumber: 1,
            browseTime: 1,
            isattach: 1,
            areaIp: this.ip || "",
            equipment: "",
          })
          .then(() => {});
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables.less";

.list-info-wrapper {
  background-color: @bg-base;
}

.Crumbs {
  padding: 20px 0;
  font-size: 14px;
  color: @text-secondary;
  span {
    color: @text-main;
    font-weight: 500;
  }
  a:hover {
    color: @primary-color;
  }
}

.main-content {
  padding-bottom: 80px;
}

.detail-card {
  background: #ffffff;
  padding: 60px 80px;
  border-radius: @border-radius;
}

.detail-header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid @border-color;

  .title {
    font-size: 28px;
    font-weight: 700;
    color: @text-main;
    margin-bottom: 24px;
    line-height: 1.4;
  }

  .meta-info {
    font-size: 14px;
    color: @text-muted;
    display: flex;
    justify-content: center;
    gap: 32px;
    i {
      margin-right: 6px;
    }
  }
}

.detail-body {
  font-size: 16px;
  line-height: 1.8;
  color: @text-secondary;
  min-height: 400px;

  /deep/ img {
    max-width: 100% !important;
    height: auto !important;
    border-radius: 4px;
    margin: 24px 0;
  }

  /deep/ p {
    margin-bottom: 16px;
  }

  /deep/ table {
    width: 100% !important;
    border-collapse: collapse;
    margin: 24px 0;
    td,
    th {
      border: 1px solid @border-color;
      padding: 12px;
    }
  }
}

.gov-link-box {
  margin-top: 40px;
  padding: 20px;
  background: @primary-light;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: @text-main;
  font-size: 15px;

  i {
    font-size: 20px;
    color: @primary-color;
  }
  a {
    color: @primary-color;
    font-weight: 600;
    text-decoration: underline;
  }
}

.detail-footer {
  margin-top: 60px;
  padding-top: 32px;
  border-top: 1px solid @border-color;
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .detail-card {
    padding: 32px 20px;
  }
  .detail-header .title {
    font-size: 22px;
  }
  .meta-info {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
